/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IPlatformAndArenaFee,
  IPlatformAndArenaFeeInterface,
} from "../IPlatformAndArenaFee";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IPlatformAndArenaFee__factory {
  static readonly abi = _abi;
  static createInterface(): IPlatformAndArenaFeeInterface {
    return new utils.Interface(_abi) as IPlatformAndArenaFeeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IPlatformAndArenaFee {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IPlatformAndArenaFee;
  }
}
